import React from "react";
import AutoTyping from "react-auto-typing";
import operationImage from "../../../assets/operation-management.jpg";
import technicianImage from "../../../assets/technician-empowerment.jpg";
import customerImage from "../../../assets/customer-engagement.png";
import contractImage from "../../../assets/contract-management.png";
import inspectionImage from "../../../assets/inspection-oversight.jpg";
import financialImage from "../../../assets/financial-management.png";

const FeaturesOnServices = () => {
  return (
    <div className="on-service-feature-section-wrapper">
      <div className="section-title">
        <h1 className="title">Our Features of On-Service</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Features"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={operationImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Operations Management</h1>
            <ul className="main-list">
              <li>
                <h6>Centralized Management</h6>
                <ul className="inner-list">
                  <li>
                    Monitor field operations from a single dashboard, tracking
                    tasks and resources in real-time to resolve issues quickly.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Automated Scheduling</h6>
                <ul className="inner-list">
                  <li>
                    Automatically assign technicians based on availability and
                    skills to reduce conflicts and ensure timely service
                    delivery.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Advanced Reporting</h6>
                <ul className="inner-list">
                  <li>
                    Generate KPI reports to evaluate efficiency and customize
                    insights to make strategic decisions.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Technician Empowerment</h1>
            <ul className="main-list">
              <li>
                <h6>Mobile Access</h6>
                <ul className="inner-list">
                  <li>
                    Technicians access job details and updates on the go,
                    ensuring real-time communication and task completion from
                    the field.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Field Inspection</h6>
                <ul className="inner-list">
                  <li>
                    Conduct inspections using mobile devices, complete digital
                    checklists, and capture real-time data for accurate
                    reporting.
                  </li>
                </ul>
              </li>
              <li>
                <h6>On-Desk Inspection</h6>
                <ul className="inner-list">
                  <li>
                    Automate inspections with digital checklists, ensuring
                    consistency and reducing paperwork.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={technicianImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={customerImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Customer Engagement</h1>
            <ul className="main-list">
              <li>
                <h6>Customer Portal</h6>
                <ul className="inner-list">
                  <li>
                    Provide a portal for customers to request services, track
                    progress, and communicate directly with the service team.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Customer Feedback and Rating</h6>
                <ul className="inner-list">
                  <li>
                    Collect feedback after each service to improve quality and
                    strengthen customer relationships.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Contract and Maintenance Management</h1>
            <ul className="main-list">
              <li>
                <h6>AMC Management</h6>
                <ul className="inner-list">
                  <li>
                    Automate maintenance reminders and manage contract details,
                    ensuring timely service and a complete service history.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Contract Renewal and Management</h6>
                <ul className="inner-list">
                  <li>
                    Simplify renewals with automated notifications and keep
                    contracts organized for easy compliance monitoring.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={contractImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={inspectionImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Inspection Oversight</h1>
            <ul className="main-list">
              <li>
                <h6>Service Center Inspection</h6>
                <ul className="inner-list">
                  <li>
                    Centralize inspection management, track performance, and
                    schedule inspections to avoid disruptions.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Inspection Quality Assurance</h6>
                <ul className="inner-list">
                  <li>
                    Implement quality control measures and review reports to
                    address recurring issues.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Financial Management</h1>
            <ul className="main-list">
              <li>
                <h6>Field Visit Expenses Management</h6>
                <ul className="inner-list">
                  <li>
                    Track field visit expenses in real-time, automate
                    reimbursements, and generate expense reports for accurate
                    budgeting.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Budget Monitoring</h6>
                <ul className="inner-list">
                  <li>
                    Monitor costs against budgets and analyze spending patterns
                    to identify savings opportunities.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={financialImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesOnServices;
